import { Redirect } from "react-router-dom";

import OnCmpLogin from "@/components/notifications/events/OnCmpLogin";
import OrganisationDashboard from "@/components/organisations/OrganisationDashboard";
import CreateOrganisationModal from "@/components/organisations/business/ui/CreateOrganisationModal";
import { useUserProfileContext } from "@/contexts/UserProfileContext";
import { useOrganisationContext } from "@/contexts/organisations/OrganisationContext";
import { CMP_WITHOUT_ORG, DASHBOARD_HOME_URL } from "@/core/urls";

function PartnerDashboard() {
  const { isPractitioner, practitionerProfile } = useUserProfileContext();

  const { organisationNotFound } = useOrganisationContext();

  if (organisationNotFound) {
    // redirecting to here will mean we use the first available
    return <Redirect to={CMP_WITHOUT_ORG} />;
  }

  if (!isPractitioner) {
    return null;
  }

  if (practitionerProfile.tier === "Practitioner") {
    return (
      <>
        <OnCmpLogin />
        <OrganisationDashboard />
        <CreateOrganisationModal />
      </>
    );
  } else if (practitionerProfile.tier === "Affiliate") {
    return <Redirect to={DASHBOARD_HOME_URL} />;
  }
  return null;
}

export default PartnerDashboard;
